import md5 from './md5'
import Cookie from './cookie'
import {AUTH_KEY} from './config'
export function queryString (obj) {
  const params = []
  for (let k in obj) {
    params.push(`${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
  }
  if (params.length === 0) {
    return ''
  }
  return params.join('&').replace(/%20/g, '+')
}
export function params2QueryString (url, obj) {
  const paramsStr = queryString(obj)
  const i = url.indexOf('?')
  return `${url}${i > 0 ? '&' : '?'}${paramsStr}`
}
export const encryptMobile = (value) => {
  let md5key, md5value
  if (value) {
    value = value.split('').sort().join('') + 'user_tel'
    md5key = md5(value).substring(4, 12)
    value = value.split('').sort().join('')
    md5value = md5(value)
    Cookie.set(md5key, md5value, false, '/', 'easteat.com')
  }
}
export const isLogin = () => {
  return !!Cookie.get(AUTH_KEY)
}
export const checkPwd = (pwd) => {
  let [ck1, ck2, ck3, length] = [pwd.replace(/\d+/, '').length, pwd.replace(/[A-Za-z]+/, '').length, pwd.replace(/[^\w]+/, '').length, pwd.length]
  if (ck1 !== 0 && ck2 !== 0 && ck3 !== 0 && ((ck1 + ck2 + ck3) < (3 * length)) && length >= 6 && length <= 20) {
    return true
  }
  return false
}




// WEBPACK FOOTER //
// ./src/assets/js/utils.js